import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-slack" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end col-md-6 col-sm-12" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_10 = { class: "setting-data" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_13 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "d-block d-md-none" }
const _hoisted_17 = { class: "d-block my-3" }
const _hoisted_18 = { class: "d-none d-md-block" }
const _hoisted_19 = { class: "d-none t-d-md-table-cell" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { colspan: "3" }
const _hoisted_23 = { class: "text-center py-2" }
const _hoisted_24 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_27 = { style: {"padding":"5px 0"} }
const _hoisted_28 = { class: "bold" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { style: {"padding":"5px 0"} }
const _hoisted_31 = { class: "bold" }
const _hoisted_32 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_34 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "d-none t-d-md-table-cell" }
const _hoisted_38 = { class: "d-none t-d-md-table-cell" }
const _hoisted_39 = { class: "sett-small-menu align-right" }
const _hoisted_40 = { class: "discl-menu dropdown" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_42 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "col-md-6 col-sm-12" }
const _hoisted_46 = { class: "area-info" }
const _hoisted_47 = { class: "col-md-6 col-sm-12" }
const _hoisted_48 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.brands), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.brandsSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.brandsSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_brands_msg), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.language.brands), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddBrandAction(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.listOfProdBrands.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_14),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_15, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.language.brands), 1)
                    ]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.language.code), 1)
                  ]),
                  _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.language.name), 1),
                  _hoisted_20
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfProdBrands.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prodBrandsPageElts, (recSuppl) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recSuppl.ProdBrandId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_24, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddBrandAction(1, recSuppl))
                        }, _toDisplayString(recSuppl.Code), 9, _hoisted_25)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.language.code) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddBrandAction(1, recSuppl))
                          }, _toDisplayString(recSuppl.Code), 9, _hoisted_29)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.language.name) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(recSuppl.BrandName), 1)
                        ]),
                        _createElementVNode("span", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddBrandAction(1, recSuppl))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_35),
                            (!_ctx.isDisabledByDef(recSuppl))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.deleteProdBrandRecord(recSuppl))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                                ], 8, _hoisted_36))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(recSuppl.BrandName), 1),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddBrandAction(1, recSuppl))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_43),
                            (!_ctx.isDisabledByDef(recSuppl))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.deleteProdBrandRecord(recSuppl))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                  _createTextVNode("  " + _toDisplayString(_ctx.language.delete), 1)
                                ], 8, _hoisted_44))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfProdBrands.length==0}])
            }, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfProdBrands.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("nav", _hoisted_48, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredProdBrands,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"])
    ]))
  ], 64))
}